import { observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import VisibilitySensor from 'react-visibility-sensor';
import { ScrollTo } from './ScrollTo';
import { Speech, SpeechProps } from './Speech';

interface SpeechWrapperProps extends SpeechProps {
    isCurrent: boolean;
}

@(withRouter as ClassDecorator)
@observer
export class SpeechScrollWrapper extends React.Component<SpeechWrapperProps> {
    componentWillUnmount(): void {
        this.props.data.setVisibility(false);
    }

    render() {
        const { isCurrent, data, ...props } = this.props;
        const top = window.innerHeight * 0.25;
        const bottom = window.innerHeight * 0.5;
        return (
            <VisibilitySensor
                partialVisibility
                scrollCheck
                resizeCheck
                intervalCheck={false}
                offset={{ top, bottom }}
                onChange={data.setVisibility}
            >
                {() =>
                    <ScrollTo when={isCurrent && !data.isVisible}>
                        <Speech data={data} {...props} />
                    </ScrollTo>
                }
            </VisibilitySensor>
        );
    }
}
